export const admin: Tamanhos = {
  search: {
    size: [
      { width: 100, order: 3, layout: 'module--full' },
      { width: 100, order: 3, layout: 'module--default' },
      { width: 100, order: 3, layout: 'module--small' },
    ],
  },
  newRequest: {
    size: [
      { width: 0, order: 0, layout: '' },
      { width: 0, order: 0, layout: '' },
      { width: 0, order: 0, layout: '' },
    ],
  },
  calc: {
    size: [
      { width: 100, order: 1, layout: 'module--full' },
      { width: 100, order: 1, layout: 'module--full' },
      { width: 100, order: 1, layout: 'module--full' },
    ],
  },
};

export const seller: Tamanhos = {
  search: {
    size: [
      { width: 50, order: 1, layout: 'module--default' },
      { width: 50, order: 1, layout: 'module--default' },
      { width: 100, order: 1, layout: 'module--small' },
    ],
  },
  newRequest: {
    size: [
      { width: 50, order: 2, layout: 'module--half' },
      { width: 50, order: 2, layout: 'module--half' },
      { width: 100, order: 2, layout: 'module--half' },
    ],
  },
  calc: {
    size: [
      { width: 100, order: 3, layout: 'module--full' },
      { width: 100, order: 3, layout: 'module--full' },
      { width: 100, order: 3, layout: 'module--full' },
    ],
  },
};

export interface Tamanhos {
  search: { size: ColRow[] };
  newRequest: { size: ColRow[] };
  calc: { size: ColRow[] };
}

export interface ColRow {
  width: number;
  order: number;
  layout: string;
}
